import React from "react";
import PropTypes from "prop-types";
import { ToggleButton, ToggleButtonGroup } from "@td/ui";
import { translate } from "@td/shared_utils";
import { SpecialtyFilterContainer } from "../components";
import { useSpecialty } from "../contexts/specialty-context";

const SpecialtyFilter = React.memo(({ specialties }) => {
  const { specialty, setSpecialty } = useSpecialty();

  return (
    <SpecialtyFilterContainer>
      <ToggleButtonGroup
        value={specialty}
        onChange={setSpecialty}
      >
        {specialties.map((specialty) => (
          <ToggleButton
            key={specialty}
            value={specialty}
          >
            {translate(null, "panels.specialties", specialty)}
          </ToggleButton>
        ))}
      </ToggleButtonGroup>
    </SpecialtyFilterContainer>
  );
});

SpecialtyFilter.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

SpecialtyFilter.displayName = "SpecialtyFilter";

export default SpecialtyFilter;
